<script>
/**
 * StackedBarChart creates a stacked bar visualization based on the 
 * predefined configuration definition and the data provided as 'stats' 
 * prop. Reactive to data changes.
 */

import { Bar, mixins } from 'vue-chartjs';

export default {
    extends: Bar,
    name: 'StackedBarChart',
    mixins: [ mixins.reactiveData ],
    props: {
        stats: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.renderChart(this.stats, this.options());
    },
    updated() {
        this.renderChart(this.stats, this.options());
    },
    methods: {
        options() {
            const colors = this.$vuetify.theme.isDark ? 
                this.$vuetify.theme.themes.dark : this.$vuetify.theme.themes.light;

            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        stacked: true,
                        gridLines: {
                            borderDash: [4, 4],
                            color: this.$vuetify.theme.themes.dark.dddarkblue
                        },
                        ticks: {
                            fontColor: colors.ddwhite,
                            fontSize: 14
                        }
                    }],
                    yAxes: [{
                        stacked: true,
                        gridLines: {
                            borderDash: [4, 4],
                            color: this.$vuetify.theme.themes.dark.dddarkblue
                        },
                        ticks: {
                            fontColor: colors.ddwhite,
                            fontSize: 14
                        }
                    }]
                },
                legend: { display: false },
                plugins: { datalabels: false }
            };
        }
    },
    watch: {
        stats(newStats) {
            this.renderChart(newStats, this.options());
        }
    }
}
</script>
